import React, { Component } from 'react';
import { Row, Col, Form, Card, Input, Icon, Select } from 'antd';
import { ssFormUtils, ssFormValidationUtils } from '@bit/ui-common.ui-components/ss-utils';


const { generateCountryOptionsFromCommonData } = ssFormUtils;

export default class EmailPassportDetails extends Component {
    constructor(props) { super(props); }

    filterSelectOptions(input, option){
        return option.props.children.toLowerCase().startsWith(input.toLowerCase().trim());
    }
    render() {
        const
        { state, services } = this.props,
        { passportNumber, passportCountry } = state.passwordReset,
        { geoDataStore } = state.geoData;
        return (
            <div>
                <div style={{
                    boxShadow: 'rgb(184, 184, 184) 0px 0px 20px',
                    borderRadius: '10px',
                    borderStyle: 'solid',
                    borderColor: 'rgb(200, 200, 200)',
                    borderWidth: '1px'
                }}>
                    <Card style={{
                        borderRadius: '10px',
                        borderStyle: 'solid',
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: '1px'
                    }}>
                        <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '10px' }}>
                            <Col>
                                <Form.Item
                                    label={(
                                        <span>
                                            {'Passport Number '}
                                            <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
                                                {'(required for Candidates only)'}
                                            </span>
                                        </span>
                                    )}
                                    required={true}
                                    style={{ width: '300px' }}
                                >
                                    <Input
                                        size='small'
                                        placeholder='Passport Number'
                                        prefix={(<Icon type='barcode' />)}
                                        onChange={e => services.updateResetField(e.target.name, e.target.value)}
                                        value={passportNumber}
                                        name='passportNumber'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row type='flex' justify='space-around' align='middle'>
                            <Col>
                                <Form.Item
                                    label={(
                                        <span>
                                            {'Passport Country '}
                                            <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
                                                {'(required for Candidates only)'}
                                            </span>
                                        </span>
                                    )}
                                    required={true}
                                    style={{ width: '300px' }}
                                >
                                    <Select
                                        showSearch
                                        allowClear
                                        size='small'
                                        showArrow={false}
                                        placeholder='Password Country'
                                        style={{ width: '100%' }}
                                        onChange={(v, o) => services.updateResetField('passportCountry', v)}
                                        value={passportCountry}
                                        filterOption={this.filterSelectOptions}
                                    >
                                    {generateCountryOptionsFromCommonData(geoDataStore)
                                    }</Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </div>
            </div>
        );
    }
}
